import type { InstallationDto } from "@sitescene/types";

import { apiClient } from "../client";
import { endpoints } from "../endpoints";

/**
 * Installations API Service
 *
 * Pure functions for installation-related API calls.
 * No React dependencies - can be used anywhere.
 */

export const installationsApi = {
	/**
	 * List all installations for the tenant
	 */
	list: async (): Promise<InstallationDto[]> => {
		const response = await apiClient.get<InstallationDto[]>(
			endpoints.installations.get,
		);
		return response.data;
	},
};
